import { useQuery } from '@tanstack/react-query';

import { getFileUrl } from '../utils/axios';
import { queryKeys } from './queryKeys';

interface Params {
  projectId: string;
  installationId: string | number;
  noRetry?: boolean;
  enabled?: boolean;
}

export function useInstallationMap({
  projectId,
  installationId,
  noRetry = false,
  enabled = true,
}: Params) {
  const url = `/projects/${projectId}/installations/${installationId}/map`;

  const { data, error, isLoading, refetch, isFetching } = useQuery<string>({
    queryKey: queryKeys.getInstallationMap(projectId, installationId),
    queryFn: ({ signal }) => getFileUrl({ url, signal }),
    enabled: !!projectId && !!installationId && enabled,
    retry: !noRetry,
    // Retain the image for this app session; uploads invalidate it explicitly.
    staleTime: Infinity,
    gcTime: Infinity,
  });

  return {
    imgUrl: data,
    error,
    isLoading,
    isFetching,
    refetch,
  };
}
